import React from 'react';
import "./BussinessConsultency.css";
import servBnr3 from "../../../assets/imgs/services/servBnr3.jpg";
import bcbnr from "../../../assets/imgs/services/bcbnr.jpg";
import ReadyToBusiness from '../../ReadyToBusiness/ReadyToBusiness';
import PropTypes from "prop-types";

import { Button } from "@mui/material";
import { Helmet } from "@dr.pogodin/react-helmet";

function BussinessConsultency({open, openContactForm }) {
  const handleWhatsApp = () => {
    window.open("https://wa.me/919876543210", "_blank");
  };

  return (
    <div className='serpMn'>
       <Helmet>
              <title>Business Consultancy & Advisory |  PAYTECH ADVISOR</title>
            </Helmet>
      <div className="bcBnr">
        <div className="maxW">
          <div className="bcBnrLft">
            <div className='bcblfCon'>
              <h1>Business Consultancy & Advisory</h1>
              <p>Insights That Drive Impact.</p>
              <div className='serDtBTns'>
                <Button variant="contained" onClick={openContactForm}>
                  Enquire Now
                </Button>
               
              </div>
            </div>
          </div>
        </div>

        <div className="bcBnrRyt">
          <img src={servBnr3} alt="servBnr3" />
        </div>
      </div>

      <div className='hdPaWrp'>
        <div className="maxW">
          <h3>At Business Consultancy, we go beyond advice</h3>
          <p>
       At Paytech Advisors, we don’t just advise — we transform businesses. Our consultancy approach blends market intelligence, operational expertise, and growth-driven strategies to help you navigate challenges and seize opportunities with confidence.
</p>
<p>Paytech Advisors is committed to helping businesses multiply their revenues profitably and sustainably, while actively contributing to the growth of the startup ecosystem. We love working with founders who are eager to scale and need expert support to make it happen.</p>
<p>We work closely with you to understand your business model, competitive landscape, and long-term vision. From optimizing operations and refining market strategies to identifying new revenue streams, every recommendation we make is tailored to achieve measurable, sustainable results. With Paytech Advisors, you gain a strategic partner who is as invested in your success as you are.</p>
<h3>Growth Advisory & Startup Consulting</h3>
<p>
At Paytech Advisors, our mission is to empower startups and businesses to achieve rapid, yet sustainable, growth. We design customised solutions and assist in the execution of proven growth strategies, ensuring that you scale without compromising profitability.
          </p>
          <p></p>
          <h3>Why Paytech Advisors?</h3>
          <p>
          Are you a founder struggling with growth and profitability? We may have the solution. By leveraging our strategic alliances with industry experts, we help you identify the right partners and strategies tailored to your business needs. Our focus is not just on growth, but on building a scalable and sustainable business.
          </p>
          <p>We help startups and businesses multiply revenues profitably & sustainably. At Paytech Advisors, we connect you with industry experts who design and execute customised growth strategies for your business. Our mission is simple: simplify solutions, serve founders, and scale with impact. businesses.
Together, we aim to simplify solutions, serve with integrity, and support founders in turning bold ideas into thriving ventures.
</p>
        </div>
      </div>

      <div className="bcmthd">
        <div className="maxW">
          <h2> Our Business Consultancy Services Include</h2>
          <div className="bcmthMn">
            <div className='mths mthC1'>
              <h4>Market Research & Analysis</h4>
              <p>Gain actionable insights into your industry, customer behavior, and competitors to make informed decisions.</p>
            </div>

            <div className='mths mthC2'>
              <h4>Strategy & Planning</h4>
              <p>Design growth strategies, operational frameworks, and expansion plans to achieve sustainable results.</p>
            </div>

            <div className='mths mthC3'>
              <h4>Financial Advisory</h4>
              <p>Access financial planning, cost optimization, and investment advisory for smarter business decisions.</p>
            </div>

            <div className='mths mthC4'>
              <h4>Operational Excellence</h4>
              <p>Optimize workflows, improve productivity, and adopt best practices for higher efficiency and scalability.</p>
            </div>
          </div>
        </div>
      </div>

      <div className='bcBnrWrp'>
        <div className="maxW">
          <img src={bcbnr} alt="bcbnr-img" />
          <p>
            By addressing inefficiencies and providing data-driven strategies, we empower businesses to grow faster, serve customers better, and stay competitive. With our consultancy, you gain a partner who ensures your business is future-ready.
          </p>
        </div>
      </div>

      <div>
        <ReadyToBusiness />
      </div>
    </div>
  );
}
BussinessConsultency.propTypes = {
  open: PropTypes.bool,
  openContactForm: PropTypes.bool,
};

BussinessConsultency.defaultProps = {
  open: false,
  openContactForm: false,
};
export default BussinessConsultency;
